import { createStore, action } from "easy-peasy";

export const store = createStore({
  loading: false,
  account: null,
  launched: false,
  front: null,
  frontUrls: [],
  backendUrls: [],
  savingSafety: false,
  copied: null,
  setLaunched: action((state, payload) => {
    state.launched = payload;
  }),
  setFront: action((state, payload) => {
    state.front = payload;
  }),
  setBackendUrls: action((state, payload) => {
    state.backendUrls = payload;
  }),
  setFrontUrls: action((state, payload) => {
    state.frontUrls = payload;
  }),
  setLoading: action((state, payload) => {
    state.loading = payload;
  }),
  setCopied: action((state, payload) => {
    state.copied = payload;
  }),
  activeLanguage: "",
  setActiveLanguage: action((state, payload) => {
    state.activeLanguage = payload;
  }),
  setAccount: action((state, payload) => {
    state.account = payload;
  }),
  setSavingSafety: action((state, payload) => {
    state.savingSafety = payload;
  }),
});
